import { EMPTY_ADDRESS } from 'types/address';

export const pickByType = (components, type) => components.find((component) => component.types?.includes(type));

export const parseAddressData = (addressData) => {
	if (!addressData || typeof addressData !== 'object') {
		return { ...EMPTY_ADDRESS };
	}

	const address = {
		street: addressData.street || '',
		street_line_two: addressData.street_line_two || '',
		city: addressData.city || '',
		state: addressData.state || '',
		zipcode: addressData.zipcode || '',
	};

	if (typeof addressData.latitude === 'number') {
		address.latitude = addressData.latitude;
	}
	if (typeof addressData.longitude === 'number') {
		address.longitude = addressData.longitude;
	}

	return address;
};
